import type { EnemyKind } from './nightmares.ts';

/**
 * Seasons: around a holiday the game changes (looks, difficulty, its own creatures) and goes back to
 * normal on its own when the dates pass. The season comes from the real time the campaign already
 * passes in (UTC dates, so every campaign agrees), never from a clock inside the sim.
 *
 * To add a holiday: add its id to SeasonId, an entry here (dates and what it changes), its texts
 * (`season.<id>.*` in i18n) and its looks (the render reads the season id from the battle).
 */
export type SeasonId = 'halloween';

export interface SeasonDef {
  id: SeasonId;
  /** First and last day, [month, day] in UTC, inclusive; the last day runs on until `graceHours` after midnight (so it covers that day in the Americas too). */
  from: [number, number];
  to: [number, number];
  graceHours: number;
  /** Nightmares' health and damage, bp. */
  hpBp: number;
  damageBp: number;
  /** A creature of the season that joins the waves: one extra next to each nightmare, with this chance (bp). */
  extra: { kind: EnemyKind; chanceBp: number } | null;
}

export const SEASONS: SeasonDef[] = [
  // The Night of Nightmares: until the end of All Saints' Day.
  { id: 'halloween', from: [10, 24], to: [11, 1], graceHours: 6, hpBp: 11200, damageBp: 11000, extra: { kind: 'pumpkin', chanceBp: 1500 } },
];

export const SEASON_BY_ID: Record<SeasonId, SeasonDef> = Object.fromEntries(SEASONS.map((x) => [x.id, x])) as Record<SeasonId, SeasonDef>;
